<template>
  <div class="wrapper">
    <div class="top" @click="routeLink('/internship/plan')">
      <div class="title">软件工程专业2019级专业实习计划</div>
      <div class="text">起止时间: 2021.09.15～2022.01.15</div>
      <div class="text">实习类别: 顶岗实习</div>
      <div class="text">实习对象: 2019级软件工程专业1班</div>
    </div>
  </div>
</template>

<script>
export default {
    data() {
      return {

      }
    },
  methods: {
      routeLink(path){
          this.$router.push({
              path
          })
      }
  },
};
</script>

<style lang="less" scoped>
body{
  margin-top: 0 !important;
}
.wrapper {
  width: 100%;
  min-height: 100vh;
  background: #F2F2F4;
  .top {
    // width: 345px;
    height: 123px;
    background: #ffffff;
    border-radius: 8px;
    margin: 0 15px 0 15px;
    .title {
      // margin-top: 12px;
      margin-bottom: 7px;
      line-height: 25px;
      font-weight: bold;
      font-size: 18px;
      color: #333333;
      letter-spacing: 0;
      margin-left: 20px;
    }
    .text {
      margin-top: 2px;
      line-height: 20px;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      letter-spacing: 0;
      margin-left: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/planList.vue